import { render } from "./ShareSocial.vue?vue&type=template&id=b789681c"
import script from "./ShareSocial.vue?vue&type=script&lang=js"
export * from "./ShareSocial.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__